module.exports = __webpack_public_path__ + "img/mgs_logo.3cab03ad.png";